<template>
	<div class="uaqiContainer">
		<div 
			class="box radiation" 
			:class="`bg-uaqi-${uaqi.radiation}/50 border-1 border-uaqi-${uaqi.radiation}`"
		>
			Радіація
		</div>
		<div 
			class="box pm" 
			:class="`bg-uaqi-${uaqi.pm}/50 border-1 border-uaqi-${uaqi.pm}`"
		>
			Мікропил
		</div>
		<div 
			class="box other-gases" 
			:class="`bg-uaqi-${uaqi.otherGases}/50 border-1 border-uaqi-${uaqi.otherGases}`"
		>
			Інші гази
		</div>
		<div 
			class="box main-gases" 
			:class="`bg-uaqi-${uaqi.mainGases}/50 border-1 border-uaqi-${uaqi.mainGases}`"
		>
			Основні гази
		</div>
		<div class="center-box-bg bg-background"></div>
		<div 
			class="center-box"
			:class="`bg-uaqi-${uaqi.main}/50 border-1 border-uaqi-${uaqi.main}`"
		>
			<div class="text-4xl font-bold">
				{{ uaqi.value }}
				{{ levelToText[uaqi.main] }}
			</div>
			<small>рівень</small>
		</div>
	</div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
	uaqi: Object
})

const levelToText = [ "-", "I", "II", "III", "IV", "V", "VI", "VII" ]
</script>

<style scoped>
.uaqiContainer {
	display: grid;
	grid-template-areas:
		"radiation pm"
		"other-gases main-gases";
	gap: 7px;
	grid-template-columns: 49% 49%;
	justify-content: space-around;
	position: relative;

	user-select: none;
}

.box {
	display: flex;
	box-sizing: border-box;

	border-radius: 10px;
	padding: 10px;
	height: 60px;

	transition: all 0.5s ease;
}

.center-box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	
	padding: 20px;
	border-radius: 50%;

	/* box-shadow: 0px 1px 20px 5px #00000020; */

	/* border: 6px solid #101010; */
	
	font-size: medium;
	text-align: center;
	
	width: 95px;
	height: 95px;
	
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}


.center-box-bg {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	
	border-radius: 50%;
	
	width: 110px;
	height: 110px;
}

/* .center-box::backdrop */

.pm {
	grid-area: pm;
	display: flex;
	justify-content: right;
}

.radiation {
	grid-area: radiation;
}

.main-gases {
	grid-area: main-gases;
	display: flex;
	justify-content: right;
	align-items: end;
}

.other-gases {
	grid-area: other-gases;
	display: flex;
	align-items: end;
}
</style>